var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { LazyEmitter } from './RenderThread';
import { generateUuid } from '../utils';
import { MessageType } from '../index';
/**
 * 消息相关的抽象类
 */
var MessageModel = /** @class */ (function (_super) {
    __extends(MessageModel, _super);
    function MessageModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.messageQueue = [];
        // 离线消息
        _this.offlineMessageQueue = [];
        // 输入框
        _this.inputMessage = '';
        // 用户是否在打字
        _this.isTyping = false;
        // 正在输入中
        _this.isInputting = false;
        _this.needScroll = false;
        _this.leaveMessageSendTag = false;
        // 客服是否在线
        _this.serviceOnline = false;
        _this.inputMessageSource = {};
        // 是否猜你想问disabled
        _this.recommendDisabled = false;
        return _this;
    }
    // 消息上屏
    MessageModel.prototype.pushMessage = function (messages, option) {
        var _a;
        if (option === void 0) { option = {}; }
        var _b = option.insertIndex, insertIndex = _b === void 0 ? this.messageQueue.length : _b;
        if (Array.isArray(messages)) {
            var nextMessage = messages.map(function (msg) { return (__assign(__assign({ msg_read_status: false, msg_is_new: true }, msg), { msg_id: generateUuid(), msg_time: new Date().getTime() })); });
            (_a = this.messageQueue).splice.apply(_a, __spreadArray([insertIndex, 0], nextMessage, false));
        }
        else {
            this.messageQueue.splice(insertIndex, 0, __assign(__assign({ msg_read_status: false, msg_is_new: true }, messages), { msg_id: generateUuid(), msg_time: new Date().getTime() }));
            // this.messageQueue.push({
            //   msg_read_status: false,
            //   msg_is_new: true,
            //   ...messages,
            //   msg_id: generateUuid(),
            //   msg_time: new Date().getTime(),
            // });
        }
        this.messageQueue = __spreadArray([], this.messageQueue, true);
        // 处理已读
        this.handleMsgRead();
        this.onUpdate();
        this.onMessageUpdate();
        this.needScroll = true;
    };
    // 消息已读
    MessageModel.prototype.handleMsgRead = function () {
        var _this = this;
        // 判断客服是否在线
        if (this.serviceOnline) {
            setTimeout(function () {
                var currentTime = new Date().getTime() - 1000;
                _this.messageQueue.forEach(function (msg, index) {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    var type = msg.type, msg_read_status = msg.msg_read_status, msg_time = msg.msg_time;
                    if (type === MessageType.Customer && !msg_read_status) {
                        if (msg_time && msg_time <= currentTime) {
                            // 改变消息队列中状态
                            _this.messageQueue[index] = __assign(__assign({}, msg), { msg_read_status: true });
                            _this.messageQueue = __spreadArray([], _this.messageQueue, true);
                            _this.onUpdate();
                        }
                    }
                });
            }, 1000);
        }
    };
    // 离线消息
    MessageModel.prototype.pushOfflineMessage = function (messages) {
        if (Array.isArray(messages)) {
            this.offlineMessageQueue = __spreadArray(__spreadArray([], this.offlineMessageQueue, true), messages, true);
        }
        else {
            this.offlineMessageQueue.push(messages);
        }
        this.onUpdate();
    };
    MessageModel.prototype.deleteMessage = function (messageId) {
        this.messageQueue = this.messageQueue.filter(function (msg) { return msg.msg_id !== messageId; });
    };
    MessageModel.prototype.updateInputMessage = function (nextMessage, isFocusInput) {
        if (isFocusInput === void 0) { isFocusInput = false; }
        this.inputMessage = nextMessage;
        if (isFocusInput) {
            // 调起输入框
            var dom = document.getElementById('message-input');
            dom === null || dom === void 0 ? void 0 : dom.focus();
        }
        this.onUpdate();
    };
    MessageModel.prototype.updateInputMessageSource = function (source) {
        this.inputMessageSource = source;
        this.onUpdate();
    };
    MessageModel.prototype.getAllMessage = function () {
        return this.messageQueue;
    };
    MessageModel.prototype.getMessageByType = function (type) {
        return this.messageQueue.filter(function (msg) { return msg.type === type; })[0];
    };
    MessageModel.prototype.getMessageById = function (id) {
        return this.messageQueue.filter(function (msg) { return msg.msg_id === id; })[0];
    };
    MessageModel.prototype.getMessageIndexByType = function (type) {
        return this.messageQueue.findIndex(function (msg) { return msg.type === type; });
    };
    MessageModel.prototype.setIsTyping = function (isTyping) {
        this.isTyping = isTyping;
    };
    MessageModel.prototype.updateRecommendDisabled = function (disabled) {
        this.recommendDisabled = disabled;
        this.onUpdate();
    };
    MessageModel.prototype.onUpdate = function () {
        this.emitRenderEvent('onUpdate');
    };
    MessageModel.prototype.onMessageUpdate = function () {
        this.emitRenderEvent('onMessageUpdate');
    };
    MessageModel.prototype.autoScroll = function () {
        var _this = this;
        var scrollContainer = document.querySelector('.content');
        setTimeout(function () {
            _this.needScroll = false;
            var el = scrollContainer;
            el.scrollTop = 50000;
            document.documentElement.scrollTop = 50000;
            window.pageYOffset = 50000;
            document.body.scrollTop = 50000;
        }, 16);
    };
    MessageModel.prototype.setInputing = function (isInputting) {
        this.isInputting = isInputting;
        this.onUpdate();
    };
    MessageModel.prototype.updateServiceOnline = function (serviceOnline) {
        this.serviceOnline = serviceOnline;
    };
    return MessageModel;
}(LazyEmitter));
export { MessageModel };
